export const styles = {
  overlayCamera: {
    zIndex: "9999999",
    position: "absolute",
    left: 0,
    top: "56px",
    width: "100%",
    // height: "82%",
    backgroundColor: "rgba(251, 251, 251, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: '10px',
  },
  shield: {
    width: "217px",
    zIndex: 9999999,
    opacity: 0.85
  },
};
